import React from "react";
import { Tabs, Tab } from "@mui/material";

export default function CampaignDetailsTabs({ activeTab, handleTabChange }) {
    return (
        <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
                px: 3,
                borderBottom: 1,
                borderColor: 'divider',
                '& .MuiTab-root': {
                    textTransform: 'none',
                    fontWeight: 500,
                    minHeight: '48px'
                }
            }}
        >
            <Tab label="Informações Gerais" />
            <Tab label="Itens da Campanha" />
        </Tabs>
    );
}
